// Presentation only: existing device names/IDs and the gateway API protocol stay
// unchanged. Older factory/default names should use the same language as the UI.
export function connectionStationText(text?: string | null) {
  return (text ?? '').replace(/\b(?:esp[- ]?32|gateway)\b/gi, 'Trạm kết nối');
}
export function connectionStationName(name?: string | null) {
  return connectionStationText(name?.trim()) || 'Trạm kết nối';
}
